export default "__VITE_ASSET__BEOOwhui__"